import { Component, OnInit } from '@angular/core';
import { LessonList, LessonListService } from 'src/app/core/http/lessonList/lesson-list.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-adm-lessons',
  templateUrl: './adm-lessons.component.html',
  styleUrls: ['./adm-lessons.component.css']
})
export class AdmLessonsComponent implements OnInit {
  course_id= '-1';
  openedIndex = null;
  lessons: LessonList[];
  LessonForm = new FormGroup({
    name: new FormControl(''),
    theory: new FormControl('')
  });
  status='Редактирование';
  constructor(private lessonListService: LessonListService, private route: ActivatedRoute,  private _fb: FormBuilder) { 
    this.course_id = this.route.snapshot.paramMap.get("course");
  }
  ngOnInit(): void {
    this.getCourses();
  }

  getCourses() {
    this.lessonListService.GetAll(this.course_id)
    .subscribe(resp=> {
      this.lessons = resp;
    })
  }
  DefaultValue(i, lesson){
    this.openedIndex = i;
    this.status = 'Редактирование';
    this.LessonForm = this._fb.group({
      name: [lesson.name],
      theory: [lesson.theory]
    });
  }
  editLesson(id,i) {
    var EditedLesson:LessonList;
    EditedLesson = this.LessonForm.value;
    EditedLesson.id = id;
    this.lessonListService.EditLesson(id, this.LessonForm.value)
    .subscribe(resp => {
      console.log(resp);
      this.lessons[i]=EditedLesson;
      this.status = 'Сохранено';
    })
  }

  addLesson() {
    this.lessonListService.AddLesson(this.course_id, this.LessonForm.value)
    .subscribe(resp=> {
      this.lessons.push(resp);
      this.LessonForm.reset();
    });
  }

  deleteLesson(id, i) {
    this.lessonListService.DeleteLesson(id)
    .subscribe(resp=>{
      console.log(resp);
      this.status = '';
    })
    if (i !== -1) {
        this.lessons.splice(i, 1);
    } 
  }

}
